import { Button, Modal, TextField } from '@nike/eds'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

interface UsernamePasswordModalProps {
  onSubmit: (username: string, password: string) => void
}

export const UsernamePasswordModal = ({ onSubmit }: UsernamePasswordModalProps) => {
  const { t } = useTranslation()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = () => {
    if (!username || !password) {
      return
    }

    setIsSubmitting(true)
    try {
      onSubmit(username, password)
    } catch (error) {
      console.error('UsernamePasswordModal: Error in onSubmit:', error)
    }
    setIsSubmitting(false)
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSubmit()
    }
  }

  return (
    <Modal
        isOpen={true}
        onDismiss={() => { console.log('Cannot let you do that, Dave.') }}
        onSubmit={handleSubmit}
        className="username-password-modal"
        headerSlot={(<>{t('login_modal.title')}</>)}
        footerSlot={
          <Button
            onClick={handleSubmit}
            size="small"
            disabled={isSubmitting || !username || !password}
          >
            {isSubmitting ? t('login_modal.authenticating') : t('buttons.submit')}
          </Button>
        }
    >
      <TextField
        id="username"
        label={t('login_modal.username_label')}
        placeholder={t('login_modal.username_placeholder')}
        className='mb-4'
        value={username}
        onChange={(e) => { setUsername(e.currentTarget.value) }}
        onKeyDown={handleKeyDown}
        disabled={isSubmitting}
        required
        autoFocus={true}
      />
      <TextField
        id="password"
        label={t('login_modal.password_label')}
        type="password"
        placeholder={t('login_modal.password_placeholder')}
        value={password}
        onChange={(e) => { setPassword(e.currentTarget.value) }}
        onKeyDown={handleKeyDown}
        disabled={isSubmitting}
        required
      />
    </Modal>
  )
}
